'use client';

import React, { useRef } from 'react';
import { useTranslations } from 'next-intl';
import styles from './HIPAACompliance.module.css';
import { Container } from '../..';
import SecurityLogo from './SecurityLogo';

const Section = React.forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement>
>(({ className, children, ...props }, ref) => (
  <section
    ref={ref}
    className={className ? `${styles.section} ${className}` : styles.section}
    {...props}
  >
    {children}
  </section>
));

Section.displayName = 'Section';

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.wrapper}>{children}</div>
);

const InnerContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.innerContainer}>{children}</div>
);

const IconWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.iconWrapper}>{children}</div>
);

const TextWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.textWrapper}>{children}</div>
);

const Title = ({ children }: { children: React.ReactNode }) => (
  <h2 className={styles.title}>{children}</h2>
);

const Subtitle = ({ children }: { children: React.ReactNode }) => (
  <p className={styles.subtitle}>{children}</p>
);

interface HIPAAComplianceProps {
  className?: string;
  htmlId?: string;
}

const HIPAACompliance = ({ className, htmlId }: HIPAAComplianceProps) => {
  const rootRef = useRef<HTMLElement>(null);
  const t = useTranslations('uhHome');

  return (
    <Section
      className={className}
      id={htmlId}
      ref={rootRef}
      aria-label={t('hipaaCompliance.ariaLabel.section')}
    >
      <Wrapper>
        <Container>
          <InnerContainer>
            <IconWrapper>
              <SecurityLogo />
            </IconWrapper>
            <TextWrapper>
              <Title>{t('hipaaCompliance.title')}</Title>
              <Subtitle>{t('hipaaCompliance.subtitle')}</Subtitle>
            </TextWrapper>
          </InnerContainer>
        </Container>
      </Wrapper>
    </Section>
  );
};

export default HIPAACompliance;
